<!-- Part of the SPARKL educational activity system, Copyright 2026 by Common Good Learning Tools -->
<template><div></div></template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	components: { },
	props: {
	},
	data() { return {
	}},
	computed: {
		...mapState(['user_info', 'site_config']),
	},
	watch: {
		// This is a placeholder component that is loaded by the router when the standards tab is clicked.
		// all it does is tell window.main_view to show the satchel iframe when we show a standards route, 
		// and hide the iframe when we go off a standards route
		// We need to do this rigamarole to ensure that the iframe is only loaded if/when the user
		// actually hits the standards tab, then remains loaded for the remainder of the user's session
		'$route.path': {immediate: true, handler(val) {
			// when the route changes to standards (showing this component)...
			if (this.$route.path.indexOf('standards') == 1) {
				window.main_view.standards_home_showing = true
			// and when the user leaves this route...
			} else {
				window.main_view.standards_home_showing = false
			}
		}},
	},
	created() {
	},
	mounted() {
	},
	methods: {
	}
}
</script>

<style lang="scss">
</style>
